function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M298.667 30.187L268.48 0 149.333 119.147 30.187 0 0 30.187l119.147 119.146L0 268.48l30.187 30.187L149.333 179.52 268.48 298.667l30.187-30.187L179.52 149.333z"
});

function SvgDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 298.667 298.667",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjk4LjY2NyAyOTguNjY3IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogIDxwYXRoIGQ9Ik0yOTguNjY3IDMwLjE4N2wtMzAuMTg3LTMwLjE4Ny0xMTkuMTQ3IDExOS4xNDctMTE5LjE0Ni0xMTkuMTQ3LTMwLjE4NyAzMC4xODcgMTE5LjE0NyAxMTkuMTQ2LTExOS4xNDcgMTE5LjE0NyAzMC4xODcgMzAuMTg3IDExOS4xNDYtMTE5LjE0NyAxMTkuMTQ3IDExOS4xNDcgMzAuMTg3LTMwLjE4Ny0xMTkuMTQ3LTExOS4xNDd6Ii8+Cjwvc3ZnPgo=";
export { SvgDelete as ReactComponent };